var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "facet-template",
    {
      attrs: { "show-clear-link": _vm.isFiltered, "facet-name": "drivetrains" },
      on: { clear: _vm.clearSelectedDriveTrains }
    },
    [
      _c("span", { attrs: { slot: "facetLabel" }, slot: "facetLabel" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$t("component.facets.driveType")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "facetBody" }, slot: "facetBody" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 p-0" },
              [
                _c(
                  "b-form-group",
                  { staticClass: "m-0" },
                  [
                    _c(
                      "b-form-checkbox-group",
                      {
                        attrs: { plain: "", stacked: "" },
                        model: {
                          value: _vm.selectedDriveTrains,
                          callback: function($$v) {
                            _vm.selectedDriveTrains = $$v
                          },
                          expression: "selectedDriveTrains"
                        }
                      },
                      _vm._l(_vm.availableDriveTrainOptions, function(option) {
                        return _c(
                          "b-form-checkbox",
                          {
                            key: option.value,
                            staticClass: "mb-2",
                            attrs: { value: option.value }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(option.text) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }